import Icon from "@web-ui/components/Icon";
import ListRow from "@web-ui/components/ListRow";
import type { Attention } from "./attention";

/**
 * Needs attention (never dismissible while something is true): one compact row per problem, each
 * leading to where it is fixed. All clear is one short line, not a card's worth of reassurance.
 */
export function NeedsAttention({ attention, stepsWaiting }: { attention: Attention[]; /** A setup step holds a publish problem. */ stepsWaiting: boolean }) {
  return (
    <section className="card flex flex-col gap-2" aria-labelledby="attention">
      <h2 id="attention" className="text-sub-title-1 ps-card-inset">Needs attention</h2>
      {attention.length === 0 ? (
        <p className="flex items-start gap-2 px-card-inset pb-1 text-body-2 text-t-secondary">
          <Icon name="check-circle" size={5} className="mt-px shrink-0 fill-positive-stroke" />
          <span>{stepsWaiting ? "All clear. Finish the marked setup step to publish." : "All clear: uploads, storage and the next publish are fine."}</span>
        </p>
      ) : <div className="flex flex-col">{attention.map((a) => <ListRow key={a.title} icon={a.icon} tone={a.tone} title={a.title} detail={a.detail} href={a.href} />)}</div>}
    </section>
  );
}
